export default {
  screens: [
    {
      type: 'intro',
      title: '冠冕艺术',
      content:
        '冠冕不仅是代表CHAUMET珍宝艺术的巅峰之作，也早已成为极具品牌辨识度的标志性象征。作为权力象征和时尚配饰，冠冕的风格从经典走向了夸张。',
      idYt: '2YX1UzJIlp0',
      videoCover: 'world/diademe/video.jpg',
      desktop: {
        cover: 'world/diademe/cover-1.jpg'
      },
      mobile: {
        cover: 'world/diademe/mobile-cover-1.jpg',
        contentStyle: { width: '90%' },
        coverStyle: {
          width: 'auto',
          height: '65%',
          bottom: '-18%',
          right: '0',
          left: 'inherit',
          position: 'absolute'
        }
      },
      isCover: true
    },
    {
      type: 'triangle',
      desktop: {
        topImg: 'world/diademe/triangleTop.jpg',
        btmImg: 'world/diademe/triangleBtm.jpg',
        cover: 'world/diademe/cover-2.jpg'
      },
      mobile: {
        topImg: 'world/diademe/triangleTop.jpg',
        btmImg: 'world/diademe/triangleBtm.jpg',
        cover: 'world/diademe/cover-2.jpg'
      },
      content:
        '自1780年开始，CHAUMET至今已创作了近3000顶的冠冕珍品，并在不同历史时期随着当时的人文背景与社会风潮，不断创造不断推陈出新，引领着整个“冠冕”领域的新貌，由此被誉为当之无愧的“冠冕大师”。 <br/><br/> 本次展览将展出的二十余顶冠冕，以及三百个镍银冠冕模型，是CHAUMET创新能力与追求卓越的有力见证。',
      isCover: true
    },
    {
      type: 'grid',
      videoBlock: {
        cover: 'world/diademe/video-diademe.jpg',
        idYt: 'IM2d5lCTqIA'
      },
      middleImg: 'world/diademe/gridMiddle.jpg',
      rightImg: 'world/diademe/gridRight.jpg',
      title: '“眩彩花园冠',
      content:
        '冕”是伦敦艺术大学中央圣马丁学院（Central Saint Mardns, UAL）珠宝创意竞赛的冠军 之作。<br/><br/> 再次参观法式花园时，斯科特•阿姆斯特朗（Scott Armstrong）构思了“眩彩花园冠冕"。CHAUMET以干脆利落的弧度和线条，映现出装饰艺术的精华。'
    }
  ],
  mobile: {
    mainContentStyle: { paddingBottom: '20px' }
  }
}



// WEBPACK FOOTER //
// ./src/locales/cn/worlds/diademe.js